











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ColorBadge_reflection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReflectPrompt",
      "kind": "LinkedField",
      "name": "prompt",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "question",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupColor",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RetroReflection",
  "abstractKey": null
};

(node ).hash = "e41acb1dd942432bb4dbbbbe54dcdcf5";

export default node;
